// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import { ReactElement } from 'react'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import { ProgressiveAsset } from '@syconium/little-miss-figgy'

import { useCart } from '../../../../app/_providers/CartProvider.client'
import { AddToBagButton } from '../../../../components/atoms/AddToBagButton'
import { CartErrorMessage } from '../../../../components/atoms/CartErrorMessage/CartErrorMessage'
import { CtaButton } from '../../../../components/atoms/CtaButton'
import { trackEvent } from '../../../../lib/analytics'
import { PriceDisplay } from '../../PriceDisplay'
import { EmbroiderySelector } from '../../quick-buy/EmbroiderySelector'
import { TrayModal } from '../../TrayModal'
import { VariantAttributeSelectors } from '../../VariantAttributeSelectors/VariantAttributeSelectors'

import {
  AddToBagButtonSection,
  Body,
  ColorNameWrap,
  ErrorMessageContainer,
  ProductImageWrapper,
  ProductPreview,
  ProductSummary,
  Style,
  VariantAttributeSelectorsWrapper,
} from './styles'

import type { ViewModel } from './types'

export const Template = ({
  addToCartWithEmbroidery,
  analyticsContext,
  availableFitsKeys,
  category,
  closeModal,
  colorGroups,
  ctaButton,
  currency,
  currentFitKey,
  currentSize,
  discountPrice,
  embroideryConfig,
  fitNames,
  imageSource,
  isActiveProductWaitlistable,
  isCurrentColorCompletelySoldOut,
  isEmbroideryVisible,
  isModalOpen,
  pdpLinkPath,
  modalTitle,
  openSizeChartModal,
  price,
  priceRange,
  productGroupTitle,
  productId,
  selectedColor,
  setSelectedColor,
  setSelectedFitKey,
  setSelectedSize,
  showColorSelector = true,
  sizeChart,
  sizes,
  sizeSectionTitle,
  userHasAttemptedInvalidAddToBag,
  onProductView,
}: ViewModel): ReactElement => {
  const { errorMessage } = useCart()

  return (
    <TrayModal
      isModalOpen={isModalOpen}
      onRequestClose={closeModal}
      overflow='visible'
      title={modalTitle}
    >
      <Body>
        {isEmbroideryVisible && embroideryConfig ? (
          <EmbroiderySelector
            fixtures={embroideryConfig}
            image={embroideryConfig.image}
            mandatoryLogoEmbroidery={embroideryConfig.mandatoryLogoEmbroidery}
            onSelect={addToCartWithEmbroidery}
            {...trackEvent({
              action: 'click',
              category: `${analyticsContext.category} embroidery selector`,
              label: 'modal embroidery',
            })}
          />
        ) : (
          <>
            <ProductPreview>
              <ProductImageWrapper>
                <Link href={pdpLinkPath} legacyBehavior={undefined} onClick={onProductView}>
                  <ProgressiveAsset.Image
                    {...trackEvent({
                      action: 'click',
                      category: analyticsContext.category,
                      label: 'Collection 2.0 (Quick Buy) - Click Product Image',
                    })}
                    key={imageSource}
                    src={imageSource}
                  />
                </Link>
              </ProductImageWrapper>
              <ProductSummary>
                <Link href={pdpLinkPath} legacyBehavior={undefined} onClick={onProductView}>
                  <Style
                    {...trackEvent({
                      action: 'click',
                      category: analyticsContext.category,
                      label: 'Collection 2.0 (Quick Buy) - Click Product Name',
                    })}
                  >
                    {productGroupTitle}
                  </Style>
                </Link>
                <ColorNameWrap>{!showColorSelector ? selectedColor?.name : ''}</ColorNameWrap>
                <PriceDisplay {...{ currency, discountPrice, price, priceRange }} />
              </ProductSummary>
            </ProductPreview>
            <VariantAttributeSelectorsWrapper>
              <VariantAttributeSelectors
                analyticsContext={analyticsContext}
                availableFitsKeys={availableFitsKeys}
                category={category}
                colorGroups={colorGroups}
                currentFitKey={currentFitKey}
                currentSize={currentSize}
                fitNames={fitNames}
                isActiveProductWaitlistable={isActiveProductWaitlistable}
                isCurrentColorCompletelySoldOut={isCurrentColorCompletelySoldOut}
                openSizeChartModal={openSizeChartModal}
                productGroupTitle={productGroupTitle}
                productId={productId}
                selectedColor={selectedColor}
                setSelectedColor={setSelectedColor}
                setSelectedFitKey={setSelectedFitKey}
                setSelectedSize={setSelectedSize}
                showColorSelector={showColorSelector}
                sizeChart={sizeChart}
                sizes={sizes}
                sizeSectionTitle={sizeSectionTitle}
                userHasAttemptedInvalidAddToBag={userHasAttemptedInvalidAddToBag}
              />
            </VariantAttributeSelectorsWrapper>

            <AddToBagButtonSection>
              <AddToBagButton
                allCaps
                block
                ButtonComponent={CtaButton}
                disabled={ctaButton.disabled}
                onClick={ctaButton.onClick}
                variant={ctaButton.variant}
                {...trackEvent({
                  action: 'click',
                  category: `${analyticsContext.category} quick buy`,
                  label: ctaButton.text,
                })}
              >
                {ctaButton.text}
              </AddToBagButton>
            </AddToBagButtonSection>
            {errorMessage && (
              <ErrorMessageContainer>
                <CartErrorMessage errorMessage={errorMessage} />
              </ErrorMessageContainer>
            )}
          </>
        )}
      </Body>
    </TrayModal>
  )
}
